var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("div", { staticClass: "navbar-tags-view" }, [_c("TagsView")], 1),
      _c(
        "div",
        { staticClass: "right-menu flex-center" },
        [
          _vm.isImpersonating
            ? _c(
                "el-button",
                {
                  staticClass: "delegated-operation-btn",
                  attrs: { type: "primary", plain: "", size: "mini" },
                  on: { click: _vm.cancelDelegatedOperation },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("cancelDelegatedOperationText")) + " "
                  ),
                ]
              )
            : _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName:
                        "v-permission:BusinessCustomerDelegatedOperation",
                      arg: "BusinessCustomerDelegatedOperation",
                    },
                  ],
                  staticClass: "delegated-operation-btn",
                  attrs: { type: "primary", plain: "", size: "mini" },
                  on: { click: _vm.showDelegatedOperationDialog },
                },
                [_vm._v(" " + _vm._s(_vm.$t("delegatedOperationText")) + " ")]
              ),
          _vm.$store.getters.cusId
            ? _c("home-help", {
                staticClass: "right-menu-item hover-effect header-icon",
              })
            : _vm._e(),
          _c("lang-select", {
            staticClass: "right-menu-item hover-effect header-icon",
          }),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c("BjKeyImage", {
                    staticClass: "user-avatar",
                    attrs: {
                      url: _vm.avatar || _vm.$getPublicImage("logo-circle.png"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticClass: "role-form",
                          attrs: {
                            "label-width": "45px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("RoleText") + ":" } },
                            [
                              _c("BjMyRoles", {
                                on: { change: _vm.onChangeRole },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticClass: "role-form",
                          attrs: { "label-position": "right" },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AccountNumberText") + ":",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "user-group-form" },
                                [
                                  _c("span", { staticClass: "loginName" }, [
                                    _vm._v(_vm._s(_vm.userInfo.loginName)),
                                  ]),
                                  _vm.showSwitch
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { plain: "" },
                                          on: { click: _vm.showUserDialog },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("changeText")))]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      staticClass: "el-dropdown-menu__item--divided",
                      nativeOn: {
                        click: function ($event) {
                          return _vm.$toPage("CommonPersonal")
                        },
                      },
                    },
                    [
                      _c("svg-icon", { attrs: { "icon-class": "user" } }),
                      _vm._v(_vm._s(_vm.$t("PersonalCenterText")) + " "),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticStyle: { display: "block" } },
                        [
                          _c("svg-icon", { attrs: { "icon-class": "logout" } }),
                          _vm._v(_vm._s(_vm.$t("ExitSystemText"))),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("UserDialog", {
        ref: "UserDialog",
        on: { isShowSwitch: _vm.isShowSwitch },
      }),
      _c("DelegatedOperationDialog", { ref: "DelegatedOperationDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }